import { cn } from '@shared/lib/cn';

import { SELECT_SKELETON_SIZE_CLASS, type SelectSize } from './select.constant';

export interface SelectSkeletonProps {
  size?: SelectSize;
  /** 너비는 부르는 쪽이 준다(기본은 부모 너비) */
  className?: string;
}

/** Select 의 status=init — 트리거 크기의 면 */
export function SelectSkeleton({ size = 'md', className }: SelectSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      className={cn(
        'skeleton-pulse',
        'w-full rounded-md bg-bg-pressed',
        SELECT_SKELETON_SIZE_CLASS[size],
        className,
      )}
    />
  );
}
